import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PLANS, PRICING_DISCLAIMER } from "../lib/plans";
import { trackVisitorEvent } from "../lib/visitorAnalytics";

function PricingCard({ plan }) {
  const onCta = () => {
    if (plan.analytics) trackVisitorEvent(plan.analytics, { plan: plan.id });
  };

  return (
    <article
      className={`pricing-card${plan.highlight ? " pricing-card-featured" : ""}`}
      data-testid={`pricing-card-${plan.id}`}
    >
      {plan.badge && <span className="pricing-badge">{plan.badge}</span>}
      <header>
        <h3>{plan.title}</h3>
        <p className="pricing-price">{plan.price}</p>
        {plan.afterPrice && <p className="pricing-after muted small-note">{plan.afterPrice}</p>}
        {plan.subtitle && <p className="muted small-note">{plan.subtitle}</p>}
      </header>
      <ul className="pricing-features">
        {plan.features.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      <Link
        data-testid={plan.ctaTestId}
        className={plan.highlight ? "primary-button full" : "secondary-button full"}
        to={plan.ctaTo}
        onClick={onCta}
      >
        {plan.cta} <ArrowUpRight size={16} />
      </Link>
    </article>
  );
}

export default function PricingSection({ id = "pricing", onViewed }) {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    if (typeof onViewed === "function") {
      try {
        onViewed();
      } catch {
        /* noop */
      }
    }
  }, [onViewed]);

  return (
    <section className="pricing-section" id={id} data-testid="pricing-section">
      <div className="pricing-section-head">
        <p className="kicker">COMMERCIAL</p>
        <h2>Plans for every modernization stage</h2>
        <p className="muted">Demo without signup. Trial for real workspaces. Enterprise when you need scale.</p>
      </div>
      <div className="pricing-grid">
        {PLANS.map((plan) => <PricingCard key={plan.id} plan={plan} />)}
      </div>
      <p className="pricing-disclaimer muted small-note" data-testid="pricing-disclaimer">
        {PRICING_DISCLAIMER}
      </p>
    </section>
  );
}
